import {
  ErrorOutline as ErrorOutlineIcon,
  NotificationImportant as NotificationImportantIcon,
} from '@mui/icons-material';
import { Box, List, ListItem, ListItemButton, ListItemIcon, styled } from '@mui/material';
import { Grid } from '@mui/system';

export const MessageContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: '#ffebee',
  border: `2px solid ${theme.palette.error.main}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
  paddingTop: theme.spacing(2.5),
}));

export const OnlyMessageContainer = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(2.5),
  marginLeft: theme.spacing(1.5),
}));

export const IconContainer = styled(Grid)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const StyledNotificationIcon = styled(NotificationImportantIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: theme.spacing(4),
}));

export const Title = styled('h4')(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 700,
}));

export const ListContainer = styled(Grid)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.error.main}`,
  marginTop: theme.spacing(1),
}));

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: 0,
  '& + &': {
    marginTop: theme.spacing(0.5),
  },
  '& .MuiListItemText-multiline': {
    margin: 0,
  },
  '& .MuiListItemText-root': {
    margin: 0,
  },
  '& .MuiListItemText-primary': {
    color: theme.palette.error.dark,
    display: 'inline-block',
    fontSize: theme.spacing(1.8),
    fontWeight: 600,
  },
  '& .MuiListItemText-secondary': {
    color: '#000',
    display: 'inline-block',
    fontSize: theme.spacing(1.7),
    marginLeft: theme.spacing(1),
  },
}));

export const ListItemBox = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
  position: 'relative',
  '&:before': {
    backgroundColor: theme.palette.error.main,
    bottom: theme.spacing(0.25),
    content: '""',
    height: theme.spacing(0.25),
    left: theme.spacing(6),
    position: 'absolute',
    transition: 'width 0.3s ease-in-out',
    width: 0,
  },
  '&:hover:before': {
    width: `calc(100% - ${theme.spacing(6)}px - ${theme.spacing(2)}px)`,
  },
}));

export const ListIconContainer = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(4),
}));

export const StyledErrorOutlineIcon = styled(ErrorOutlineIcon)(({ theme }) => ({
  color: theme.palette.error.dark,
  fontSize: theme.spacing(3),
}));

export const CellList = styled(List)(({ theme }) => ({
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(4),
  paddingTop: 0,
}));

export const CellListItem = styled(ListItem)(({ theme }) => ({
  color: theme.palette.error.dark,
  fontSize: theme.spacing(1.7),
  padding: 0,
}));

export const CellButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  flexGrow: 0,
  padding: theme.spacing(0.25, 1),
}));
